import { yup } from '@guiker/shared-framework'

import { StockDelistReason } from '../../../entity'

export const delistStockSchema = yup.object<{
  reason: StockDelistReason
}>({
  reason: yup.string().oneOf(Object.values(StockDelistReason)).required(),
})
